import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.ApplicationFlagSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    applicationFlagList: { items: data, total },
  } = await sdk.getListApplicationFlag(
    filterSortPage({ filter, sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { applicationFlag: data } = await sdk.getOneApplicationFlag({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { applicationFlagMany: data } = await sdk.getManyApplicationFlag({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const applicationFlag = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
